<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@use '../../ArticleTop/Article';
@use '../../ArticleTop/ArticleTop';
@use '../../ArticleAuthor/ArticleAuthor';
@use '../../ArticleQuote/ArticleQuote';
@use '../../ArticleListLinks/ArticleListLinks';
@use '../../ArticleText/ArticleText';
@use '../../ArticleImage/ArticleImage';
@use '../../ArticleRelatedBar/ArticleRelatedBar';
@use '../../ArticleUseful/ArticleUseful';
@use '../../ArticleSpecs/ArticleSpecs';
@use '../../ArticleProConList/ArticleProConList';
@use '../../Breadcrumb/Breadcrumb';
</style>
